export type CompanyProfileLinkState = {
  discoverReturnTo?: string;
  returnTo?: string;
};

/** Public discover URL; logged-in users are redirected to the workspace. */
export function buildCompanyDiscoverPath(companyId: string, search = ""): string {
  return `/discover/${companyId}${search}`;
}

/** In-app profile entry for logged-in discovery (stays in AppLayout, then resolves to collaboration workspace). */
export function buildLoggedInCompanyProfilePath(companyId: string): string {
  return `/my-discovery/${companyId}`;
}

/** Facilitator explore/shortlist: anonymous company profile inside FacilitatorLayout. */
export function buildFacilitatorCompanyProfilePath(
  companyId: string,
  search = "",
  basePath: "/facilitator" | "/management" = "/facilitator",
): string {
  return `${basePath}/companies/${companyId}/profile${search}`;
}

/** Ecosystem head explore/shortlist: anonymous company profile inside EcosystemHeadLayout. */
export function buildEcosystemHeadCompanyProfilePath(companyId: string, search = ""): string {
  return `/ecosystem-head/companies/${companyId}/profile${search}`;
}

/** Ecosystem head managed company: full + anonymous profile toggle. */
export function buildEcosystemHeadManagedCompanyProfilePath(companyId: string): string {
  return `/ecosystem-head/companies/${companyId}/company-profile`;
}

/** Expert explore: anonymous company profile inside ExpertLayout. */
export function buildExpertPortalCompanyProfilePath(companyId: string, search = ""): string {
  return `/expert/companies/${companyId}/profile${search}`;
}

/** Expert managed company: full + anonymous profile toggle. */
export function buildExpertManagedCompanyProfilePath(companyId: string): string {
  return `/expert/companies/${companyId}/company-profile`;
}

/** Facilitator/Manager managed company hub (heads, collaborations, suggestions, profile). */
export function buildFacilitatorManagedCompanyHubPath(
  companyId: string,
  basePath: "/facilitator" | "/management" = "/facilitator",
): string {
  return `${basePath}/companies/${companyId}`;
}

/** Facilitator/Manager managed company: full + anonymous profile toggle. */
export function buildFacilitatorManagedCompanyProfilePath(
  companyId: string,
  basePath: "/facilitator" | "/management" = "/facilitator",
): string {
  return `${basePath}/companies/${companyId}/company-profile`;
}

export function companyProfileAriaLabel(gtid: string | null | undefined, fallback = "company"): string {
  return `View company ${gtid || fallback}`;
}
